import { Button, CardFooter, FormSubtitle, FormTitle } from "@impero-com/ui";

import FormCardContainer from "../components/formCardContainer";

import { getSharedErrorProps } from "./sharedError";

interface LoggedInErrorProps {
    inline?: boolean;
    title: string;
    subtitle: string;
    action: {
        label: string;
        handler: () => void;
    };
}

const LoggedInError = (props: LoggedInErrorProps) => {
    return (
        <FormCardContainer fullWidth={true} inline={props.inline}>
            <FormTitle title={props.title} />
            <FormSubtitle subtitle={props.subtitle} />
            <CardFooter>
                <Button
                    id="logged-in-error-button"
                    variant="link"
                    onClick={props.action.handler}
                >
                    {props.action.label}
                </Button>
            </CardFooter>
        </FormCardContainer>
    );
};

interface LoggedInHttpErrorProps {
    code: number | undefined;
    inline?: boolean;
}

export const LoggedInHTTPError = ({ code, inline }: LoggedInHttpErrorProps) => {
    const sharedProps = getSharedErrorProps(code);
    return <LoggedInError {...sharedProps} inline={inline} />;
};
